import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5537%3A4477
 *
 * @param {SvgIconProps} props - svg props
 */
export const ChevronUpIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M16.2343 14.8908C16.4301 15.0885 16.7497 15.0884 16.9453 14.8904L17.6528 14.1743C17.8452 13.9795 17.8452 13.6662 17.6528 13.4715L12.3557 8.11C12.1599 7.91189 11.8401 7.91188 11.6443 8.11L6.3472 13.4715C6.15477 13.6662 6.15477 13.9795 6.3472 14.1743L7.05471 14.8904C7.2503 15.0884 7.56988 15.0885 7.76569 14.8908L12 10.6144L16.2343 14.8908Z' fill={color}/>
        </SvgIcon>
    )
}

export default ChevronUpIcon
